const ChandakConfig = {
    clientId:
        'f29f4282be0c8a96ebbf01c423292eef62d963a978d571a64ac9b017d30ad0f9',
    id: 105,
    name: 'Chandak',
    fullName: 'Chandak Group',
    programName: 'Chandak Connect',
    primaryColor: '#5c9886',
    theme: 'ChandakTheme',
    favicon: 'https://cdn.loyalie.in/1730726800516_favicon_chandak',

    googleConfig: {
        gID: 'G-STLMD1CTD4',
        keywordsContent:
            'Chandak Connect Circle real estate referral programs, Chandak Connect Circle real estate referral program, Chandak Connect Circle real estate refer and earn, Chandak Connect Circle real estate project refer, Chandak Connect Circle real estate, Chandak Connect Circle real estate loyalty program, Chandak Connect Circle real estate news, Chandak Connect Circle real estate upcoming projects in Bengaluru, Chandak Connect Circle real estate launch Chandak Connect Circle real estate, Chandak Connect Circle real estate launch, Chandak Connect Circle real estate program, Chandak Connect Circle real estate projects, Chandak Connect Circle real estate blogs, Chandak Connect Circle real estate offers, Chandak Connect Circle real estate upcoming projects in Bengaluru, Chandak Connect Circle real estate events, Chandak Connect Circle, Chandak, Chandak Connect Circle real estate best residential projects, Chandak Connect Circle real estate real estate developers, All New Projects by Chandak real estate Builders & Developers, Ongoing Projects by Chandak real estate Pvt Ltd, Chandak real estate Bengaluru, Chandak real estate new program, Chandak press release, Chandak upcoming projects, Chandak property group, Chandak bangalore, Chandak real estate, Chandak Connect Circle, Chandak Connect Circle commercial projects, Chandak Connect Circle projects, Chandak Connect Circle projects in bangalore',
        descriptionContent:
            "We present to you a bouquet of such experiences and more with Chandak Connect Circle - a bespoke loyalty and referral programme that's designed exclusively for Chandak homeowners",
        authorContent: 'Chandak Connect Circle'
    },

    facebookPixelConfig: {
        id: '897934379108224', //PROD
        metaName: 'facebook-domain-verification',
        metaContent: ''
    },
    webengageLic: 'in~76aa206',
    uatFacebookPixelConfig: {
        id: '',
        metaName: '',
        metaContent: ''
    },
    manuallySelectReward: true,
    logoLeft: {
        name: 'Chandak Logo',
        url: 'https://cdn.loyalie.in/1730709308077_chandhak_circle',
        stickyNavBarLogoClass: ' h-16 pl-3 xl:pl-10',
        baseNavBarLogoClass: ' h-16 pl-3 xl:pl-10 '
    },

    logoRight: {
        name: 'ChandakInfra Logo',
        url: 'https://cdn.loyalie.in/1730709165656_logo_chandhak_group',
        stickyNavBarLogoClass: 'hidden lg:block h-16 pr-3 xl:pr-10',
        baseNavBarLogoClass: ' h-16 prl-3 xl:pr-10 '
    },

    navBarConfig: {
        dropDown: true,
        font: `font-Gotham_Book`,
        height: 'h-20 2xl:h-24',
        mobileIconColor: 'text-primary',
        dropDownBg: 'bg-white',
        showActiveLinkColor: false,
        footerNavItemClass: `tracking-widest uppercase text-white text-[12px] md:text-[14px] lg:text-white hover:text-primary-focus font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg  font-Gotham_Book`,
        baseNavBar: {
            border: true,
            borderClass: 'border-b-[3px] border-primary-focus',
            backgroundColor: 'bg-primary-content', // default: transparent
            containerClass: '',
            itemClass:
                'uppercase lg:mr-7 tracking-widest text-[14px] text-primary hover:text-primary-focus font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg ',
            dropDownContainerClass: `hover:text-primary-focus lg:hover:text-white lg:hover:bg-primary-focus lg:focus:text-primary-focus lg:focus:bg-primary lg:focus:outline-none lg:focus:shadow-outline  `,
            dropDownItemClass:
                'tracking-widest text-primary text-[14px] font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg '
        },

        stickyNavBar: {
            border: true,
            borderClass: 'border-b-[3px] border-primary-focus',
            backgroundColor: 'bg-primary-content', //default: primary-content,
            containerClass: '', //entire Nav Bar Class (add min-w-full for godrej navbar effect)
            itemClass:
                'uppercase lg:mr-7 tracking-widest  text-[14px] text-primary hover:text-primary-focus font-semibold lg:text-[12px] xl:text-[14px] 3xl:text-lg ' // Each list element in NavBar (Text color, hover color, size)
        }
    },
    bannerNegativeTopMarginClass: '', //corresponding to navBarHeightClass
    scrollToTargetAdjustedValue: 92,

    clientButtonClassName: `mx-auto text-center mt-3 font-medium text-[15px] xl:text-[17px] tracking-wider bg-primary-focus text-white py-2.5 xl:py-3 px-8 font-Gotham_Book`,

    showFooterRoutes: true,
    enableNameInputDuringLogin: true,
    routes: {
        home: {
            name: 'OVERVIEW',
            path: '/',
            show: true,

            components: [
                {
                    type: 'BANNER_NEW',
                    backgroundImage:
                        'https://cdn.loyalie.in/1730713149289_chandak_banner_final',
                    backgroundImageMobile:
                        'https://cdn.loyalie.in/1730713574477_chandak_banner_final_sm',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0'
                    },
                    bannerContainerClass:
                        'relative h-[90vh] md:h-[80vh] lg:h-[75vh] xl:h-[90vh] 2xl:h-[95vh] bg-contain bottom-radius-curve bg-center',
                    bannerItemContainerClass:
                        'items-start justify-top lg:justify-center pt-5 md:pt-0 md:px-8 md:pl-6 lg:pl-12 ',
                    position: 'text-left',

                    components: [
                        {
                            type: 'CUSTOM',
                            className:
                                'w-full text-center text-white lg:text-left mt-5 md:mt-10 lg:mt-0 lg:mb-20 leading-[1.1]',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: 'A community where',
                                    className: ` text-[25px] md:text-[28px] lg:text-[25px] xl:text-[30px] xl:text-[35px] font-Gotham_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'referrals lead to ',
                                    className: ` text-[25px] md:text-[28px] lg:text-[25px] xl:text-[30px] pt-1 xl:text-[35px] font-Gotham_Bold`
                                },
                                {
                                    type: 'TEXT',
                                    content: 'extraordinary benefits.',
                                    className: `text-[25px] md:text-[28px] lg:text-[25px] xl:text-[30px] pt-1 xl:text-[35px]  font-Gotham_Bold`
                                },
                                {
                                    type: 'BUTTON',
                                    content: 'REFER NOW',
                                    className: `mx-auto text-center md:mx-0 mt-6  text-[16px] lg:text-[15px] xl:text-[17px] 2xl:text-lg tracking-wider bg-transparent border-4 border-primary-focus text-white rounded-md py-2 md:py-2 2xl:py-[7px] px-10 md:px-5 font-Gotham_Bold`,
                                    path: 'gift-and-earn',
                                    onClick: 'CHANGE_PATH_AND_SCROLL',
                                    scrollTo: 'referral_section'
                                }
                            ]
                        },
                        {
                            type: 'CUSTOM',
                            id: '',
                            className:
                                ' w-[30%] md:w-[20%] lg:w-[12%] absolute right-[0%] bottom-[18.5%] md:bottom-[15.5%] lg:bottom-[20.5%] ',
                            components: [
                                {
                                    type: 'TEXT',
                                    content: 'Managed by',
                                    className: `text-[12px] text-white  leading-6 xl:leading-[27px] text-center font-normal break-words pb-1 font-Gotham_Book`
                                },
                                {
                                    type: 'IMAGE',
                                    url: 'https://cdn.loyalie.in/1743407646283_reloy_new_white_logo',
                                    position: 'center',
                                    className: 'w-[80%] md:w-[70%] lg:w-[90%]'
                                }
                            ]
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    id: 'overview',
                    // url: 'https://cdn.loyalie.in/43800302.png',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0.89',
                        size: '70%'
                    },
                    bannerItemContainerClass: 'bg-cover',
                    className:
                        'w-[80%] lg:w-[90%] 2xl:w-[80%] mx-auto flex flex-col justify-center text-center my-10 relative border-2 border-primary rounded-[30px]',
                    components: [
                        {
                            type: 'ICONS_LAYOUT',
                            containerClassName:
                                'h-content lg:h-auto items-center  w-[90%] 2xl:w-[85%] mx-auto -mt-36 xl:-mt-44',
                            gridClassName:
                                'flex lg:grid lg:grid-cols-3 gap-x-7 xl:gap-x-8 w-full m-auto overflow-x-scroll lg:overflow-x-hidden ',

                            infotxtClassName: ` mx-auto leading-[1.2] px-4 xl:px-6 text-secondary-focus text-[15px] xl:text-[16px] font-semibold w-full font-Gotham_Book`,
                            infoHeadingClassName: `w-full mx-auto leading-[1.1] text-[17px] xl:text-[22px] xl:text-xl  text-black font-normal px-4 xl:px-6  py-5 tracking-wide font-Gotham_Bold`,
                            infoContainerClassName:
                                'min-w-[68vw] md:min-w-[33vw] lg:min-w-full lg:mt-0 rounded-[30px] py-8 shadow-md mb-2 cursor-pointer',
                            imgContainerClassName: '',
                            imgClassName: 'w-[20%] lg:mx-auto mx-auto lg:mb-2',
                            info: [
                                {
                                    BGColor: '#d4dcef',
                                    imgUrl: 'https://cdn.loyalie.in/1730715555913_chandak_icon_1',
                                    infoHeading:
                                        'Special Offers and Savings for You',
                                    infoText:
                                        'Unlock exclusive offers & savings with Chandak Connect Circle!',
                                    path: 'deals',
                                    onClick: 'CHANGE_PATH'
                                },
                                {
                                    BGColor: '#abb9ba',
                                    imgUrl: 'https://cdn.loyalie.in/1730715616965_chandak_icon_2',
                                    infoHeading: 'Discover Key Information',
                                    infoText:
                                        'Stay updated on real estate trends with videos & blogs from Chandak Connect Circle!',
                                    path: 'blogs',
                                    onClick: 'CHANGE_PATH'
                                },
                                {
                                    BGColor: '#d4dcef',
                                    imgUrl: 'https://cdn.loyalie.in/1730715652506_chandak_icon_3',
                                    infoHeading:
                                        'Interactive Workshops and Events',
                                    infoText:
                                        'Join workshops and events that inspire creativity and connections with Chandak Connect Circle!',
                                    path: 'events',
                                    onClick: 'CHANGE_PATH'
                                }
                            ]
                        },
                        {
                            type: 'TEXT',
                            content:
                                'Discover a realm of benefits with Chandak Connect Circle.',
                            className: `font-Gotham_Bold text-black self-center text-center w-[90%] text-[20px] md:text-[25px] xl:text-[32px] 2xl:text-[35px]   leading-[1.1] py-10`
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    url: 'https://cdn.loyalie.in/1730720225902_gift%20box%20banner',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0',
                        size: 'cover'
                    },
                    onClick: 'CHANGE_PATH',
                    path: 'gift-and-earn',
                    className:
                        'w-full flex flex-col items-center justify-center mx-auto relative cursor-pointer ',
                    components: [
                        {
                            type: 'IMAGE',
                            url: 'https://cdn.loyalie.in/1740571097952_ChandakOverviewRefer',
                            position: 'center',
                            className: 'w-full h-full hidden lg:block '
                        },
                        {
                            type: 'IMAGE',
                            url: 'https://cdn.loyalie.in/1740571564381_ChandakOverviewReferSM',
                            position: 'center',
                            className: 'w-full h-full block lg:hidden'
                        }
                    ]
                },

                {
                    type: 'CUSTOM',
                    // url: 'https://cdn.loyalie.in/53618026.png',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0.30',
                        size: '90%'
                    },
                    className:
                        'xl:text-center text-center xl:w-full w-[100%] pt-8  md:pt-12 relative',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'OFFERS OF THE MONTH',
                            className: `pt-2 text-black uppercase tracking-wide leading-[1] text-[20px] md:text-[25px] xl:text-[32px] 2xl:text-[35px]  font-normal font-Gotham_Bold`
                        },
                        {
                            type: 'ANIMATE',
                            url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Chandak/divider_chandak.svg',
                            width: '90',
                            height: '64',
                            name: 'first',
                            imgHeight: 'h-12',
                            className:
                                'flex justify-center text-center m-auto text-center '
                        },
                        {
                            type: 'CAROUSEL',
                            // getVendorLogos: true,
                            offerCards: true,
                            getVendorData: true,
                            classNameCTA: `bg-black px-5 py-1.5 text-white text-center mt-2 mx-auto font-Gotham_Book`,
                            ContainerClassName:
                                'bg-cover rounded-lg h-auto mx-3 2xl:mx-5 p-8',
                            caraouselClassName: `w-[80%] md:w-full xl:w-[86%] 2xl:w-[95%] 3xl:w-[80%] mx-auto md:px-12  pt-6 relative pb-10 font-Gotham_Book`,

                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 3000,
                            infinite: true,
                            dots: false,
                            slidesToShow: 4,
                            pauseOnHover: true,
                            speed: 3000,
                            onImageClick: 'OPEN_URL_NEW_WINDOW',
                            getProjects: true
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    url: 'https://cdn.loyalie.in/1730721450799_blogs_bg',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '0',
                        size: 'cover'
                    },
                    className:
                        'w-full flex flex-col items-center justify-center bg-center mx-auto mt-12 py-10 relative bg-primary-focus',
                    components: [
                        {
                            type: 'TEXT',
                            content:
                                'Delve into our insightful Blogs for expert tips and valuable information on the latest real estate trends.',
                            className: `font-Gotham_Bold text-white self-center text-center w-[90%] lg:w-[70%] 2xl:w-[60%] text-[18px] md:text-[23px] xl:text-[30px] leading-[1.1]  2xl:leading-[1.2] py-10`
                        },
                        {
                            type: 'BLOG_LAYOUT_VERTICAL2',
                            className:
                                'w-full h-auto flex flex-col-reverse lg:flex-row mt-6 px-5 md:px-10 lg:px-5 2xl:px-16 justify-center ',
                            classNameContainer:
                                ' w-[90%] mx-auto lg:px-0 lg:w-full xl:w-[90%] overflow-x-scroll lg:overflow-x-hidden flex lg:grid lg:grid-cols-3 gap-x-4 md:gap-x-8 lg:gap-x-6 xl:gap-x-10 2xl:gap-x-16 3xl:gap-x-20 gap-y-14 ',
                            hideInfo: true
                        }
                    ]
                },
                {
                    type: 'CUSTOM',
                    url: '',
                    linearGradient: {
                        R: '255',
                        G: '255',
                        B: '255',
                        opacity: '1',
                        size: '40%'
                    },
                    className:
                        'xl:text-center text-center xl:w-full w-[100%] text-[#f58020] py-10 ',
                    components: [
                        {
                            type: 'TEXT',
                            content: 'GROUP PROJECTS',
                            className: `font-Gotham_Bold text-black text-center tracking-wide leading-[1] text-[25px] xl:text-[32px] 2xl:text-[35px]  font-normal `
                        },
                        {
                            type: 'ANIMATE',
                            url: 'https://reloy-internal.s3.ap-south-1.amazonaws.com/ClientAssets/Chandak/divider_chandak.svg',
                            width: '90',
                            height: '64',
                            name: 'second',
                            imgHeight: 'h-12',
                            className:
                                'flex justify-center text-center m-auto text-center '
                        },
                        {
                            type: 'CAROUSEL',
                            customSlide: true,
                            caraouselClassName:
                                'px-8 w-[99%] md:w-[97%] xl:w-[84%] 2xl:w-[92%] 3xl:w-[80%] mx-auto md:pb-10 pt-1 relative pb-16 lg:py-5',
                            imageContainerClassName: 'm-4 relative',
                            imageClassName:
                                'w-[93%] md:w-[92%] lg:w-[93%] xl:w-[92.5%] 2xl:w-[90%] mx-auto h-[170px] xl:h-[189px] 2xl:h-[228px] object-cover object-center lg:bg-cover',
                            captionClass: ` text-sm md:text-md xl:text-lg font-semibold leading-[1.2] font-Gotham_Bold`,

                            xlSlidesToShow: 3,
                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 3000,
                            infinite: true,
                            dots: false,
                            slidesToShow: 3,
                            pauseOnHover: true,
                            speed: 3000,
                            onImageClick: 'OPEN_URL_NEW_WINDOW',
                            getProjects: true
                        }
                    ]
                }
            ]
        }
    },
    referPage: {
        referBanner: 'https://cdn.loyalie.in/1740571801412_ChandakReferLG',
        banner: {
            loginBannerComponents: [
                {
                    type: 'BANNER',
                    linearGradient: {
                        R: '0',
                        G: '0',
                        B: '0',
                        opacity: '0.2'
                    },
                    backgroundImage:
                        'https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/JP-Infra/Images/83352489.jpg',
                    backgroundImageMobile:
                        'https://reloydev.s3.ap-south-1.amazonaws.com/Website/Uploads/JP-Infra/Images/83352489.jpg',
                    bannerContainerClassName:
                        'relative hero hero-content max-w-full h-[75vh] md:h-[70vh] object-cover bg-center lg:bg-left',
                    components: [
                        {
                            type: 'TEXT',
                            content:
                                'Refer your loved ones and get rewards on every successful referral ',
                            className: `text-center lg:text-left text-black text-[15px] md:text-[20px] xl:text-[25px] uppercase my-5 tracking-widest lg:w-[55%] ml-auto  font-Gotham_Book`
                        },
                        {
                            type: 'CUSTOM',
                            className: 'flex lg:w-[55%] ml-auto',
                            components: [
                                {
                                    type: 'BUTTON',
                                    content: 'Start Referring Now',
                                    onClick: 'OPEN_LOGIN',
                                    className: `text-center mt-3 font-medium text-[15px] xl:text-[17px] tracking-wider bg-primary-focus text-white py-2.5 xl:py-3 px-8 mx-auto lg:mx-0 font-Gotham_Book`
                                }
                            ]
                        }
                    ]
                }
            ]
        },

        components: [],

        customize: {}
    },
    blogs: {
        banner: {
            bannerContainerClassName:
                'hidden md:hero hero-content max-w-full h-[450px] bg-center md:bg-top  mx-auto text-center border-b-[3px] border-primary-focus',
            linearGradient: {
                string: '100,65,43,0.7',
                R: '20',
                G: '20',
                B: '20',
                opacity: '0.20'
            },
            backgroundImage: 'https://cdn.loyalie.in/19150976.jpg',
            backgroundImageMobile: 'https://cdn.loyalie.in/19150976.jpg',
            components: [
                {
                    type: 'TEXT',
                    content: 'CHANDAK READERS’ CLUB',
                    className: `mt-12 md:mt-10 mb-5 text-[30px] lg:text-[40px]  tracking-wider font-Gotham_Bold`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] g:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing Together Information And Entertainment For You.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-[16px] xl:text-[17px] tracking-wider font-Gotham_Book`
                },
                {
                    type: 'BUTTON',
                    content: 'Read More',
                    scrollTo: 'blogs_section',
                    onClick: 'SCROLL',
                    className: `mx-auto text-center mt-3 font-medium text-[12px] md:text-[17px] tracking-wider bg-primary-focus text-white py-3 2xl:py-3 px-12 md:px-8 font-Gotham_Book`
                }
            ],
            loginBannerComponents: [
                {
                    type: 'TEXT',
                    content: 'CHANDAK READERS’ CLUB',
                    className: `mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wider font-Gotham_Bold`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] g:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Bringing Together Information And Entertainment For You.',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wider font-Gotham_Book`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Read Now',
                    onClick: 'OPEN_LOGIN',
                    className: `mx-auto text-center mt-3 font-medium text-[12px] md:text-[17px] tracking-wider bg-primary-focus text-white py-3 2xl:py-3 px-12 md:px-8 font-Gotham_Bold`
                }
            ]
        },
        comments: {
            commentButtonClass: 'bg-primary-focus text-white',
            initialsClass: ' '
        },
        primaryColor: '',
        fontHeading: `font-Gotham_Bold`,
        fontBody: `font-Gotham_Book`,
        button: {
            position: 'self-end',
            bgColor: false,
            border: false
        },
        sliderBanner: {
            featuredPost: {
                featuredPostClass: ``,
                headingClass: `text-[30px]  uppercase tracking-tight text-secondary-focus mt-3 leading-10 break-words `,
                summaryClass: ` `
            },
            sectionHeadings: `text-black text-[32px] tracking-wide`
        },
        layout5: {
            headingClass: `!text-primary text-[16px] xl:text-[18px] tracking-tight leading-[1.2]`,
            categoryClass: ``,
            summaryClass: `leading-5 text-[15px]`,
            buttonClass: `!bg-primary-focus`,
            dateClass: ``
        }
    },
    events: {
        banner: {
            linearGradient: {
                R: '0',
                G: '0',
                B: '0',
                opacity: '0',
                size: 'cover'
            },

            negativeMargin: ' ',
            containerClass: ' text-white w-[50%] bg-top',
            heading: '',
            headingClass: ` text-center lg:w-[70%] text-[30px] xl:text-[42px] 2xl:text-[62px] text-white uppercase font-Gotham_Bold`,
            subHeading: '',
            subHeadingClass: `text-accent uppercase font-semibold text-[33px] font-Gotham_Bold`
        },
        loginBanner: {
            bannerContainerClassName:
                'mt-20 2xl:mt-24 hero hero-content lg:bg-right bg-cover max-w-full h-[55vh] md:h-[70vh] lg:h-[90vh] mx-auto text-center ',
            components: [
                {
                    type: 'TEXT',
                    content: 'CURATED WORKSHOPS AND EVENTS',
                    className: `font-semibold mt-12 md:mt-10 mb-5 text-2xl md:text-4xl lg:text-[40px] tracking-wider font-Gotham_Medium`
                },
                {
                    type: 'DIVIDER',
                    className:
                        'mt-1 self-center mx-auto w-[20%] lg:w-[20%] bg-primary border-none h-[6px]',
                    classNameContainer: ''
                },
                {
                    type: 'TEXT',
                    content:
                        'Meet and connect with like-minded people of your bespoke community',
                    className: `font-normal mt-5 mb-3  text-xl md:text-base lg:text-[17px] tracking-wider font-Gotham_Bold`
                },
                {
                    type: 'BUTTON',
                    content: 'Login To Participate Now',
                    onClick: 'OPEN_LOGIN',
                    className: `uppercase md:mt-6 text-[12px] md:text-[17px] 2xl:text-lg tracking-wider bg-primary text-white rounded-md py-2 md:py-2 2xl:py-[7px] px-10 md:px-5 font-Gotham_Bold`
                }
            ]
        },
        fontHeading: `font-Gotham_Bold`,
        fontBody: `font-Gotham_Book`,
        eventsSection: {
            headingClass: `text-[32px] xl:text-[42px] tracking-tight text-primary mt-14 leading-10 border-b-2 border-[#abb8ea] pb-2`,
            filterHeadingClass: ''
        },
        eventLayout: {
            titleClass: `!text-[22px] `
        }
    },

    deals: {
        dealsSection: {
            overlayClass: '',
            additionalTextClass: `text-primary text-2xl xl:text-3xl leading-7 xl:leading-9 font-Gotham_Bold `,
            subAdditionalTextClass: ` font-normal text-[14px] text-neutral font-Gotham_Book`,
            noDealsClass: `text-primary text-2xl text-center my-6
         font-Gotham_Book`
        },
        dealLayout: {
            listTitleClass: `text-2xl lg:text-xl leading-6 lg:leading-5 text-primary font-Gotham_Book`,
            listBodyClass: `font-Gotham_Book`,
            titleClassName: ` text-2xl xl:text-4xl text-primary  leading-7 xl:leading-9 font-normal font-Gotham_Bold `,
            couponClassName: `block text-sm md:text-base xl:text-xl text-primary font-semibold font-Gotham_Book`,
            termsAndConditionsClassName: `font-semibold capitalize text-neutral text-sm  font-Gotham_Book`,
            redeemNowButtonConfig: {
                type: 'BUTTON',
                content: 'Redeem Now',
                className: `hover:shadow-xl rounded bg-primary-focus hover:bg-primary text-white font-medium self-center text-[16px] py-2.5 px-7 py-3 2xl:py-3 px-7 md:px-8 font-Gotham_Book`
            }
        }
    },
    projects: {
        components: [
            {
                type: 'BANNER',
                linearGradient: {
                    string: '100,65,43,0.7',
                    R: '20',
                    G: '20',
                    B: '20',
                    opacity: '0.30'
                },
                backgroundImage:
                    'https://cdn.loyalie.in/1730796018639_chandak_project_banner',
                backgroundImageMobile:
                    'https://cdn.loyalie.in/1730796018639_chandak_project_banner',
                bannerContainerClassName:
                    'hidden md:hero hero-content max-w-full h-[400px]  md:bg-bottom',

                components: [
                    {
                        type: 'TEXT',
                        content: 'CHANDAK GROUP PROJECTS',

                        className: `text-center text-[30px] xl:text-[42px] 2xl:text-[62px] text-white uppercase font-Gotham_Bold`
                    },
                    {
                        type: 'DIVIDER',
                        className:
                            'mt-1 self-center mx-auto w-[40%] md:w-[35%] lg:w-[15%] xl:w-[20%] bg-primary-focus border-none h-[6px]',
                        classNameContainer: ''
                    }
                ]
            }
        ]
    },

    termsAndConditions: {
        fontHeading: `font-Gotham_Bold`,
        fontBody: `font-Gotham_Book`,
        components: [
            {
                type: 'CUSTOM',

                components: [
                    {
                        type: 'LIST',
                        listStyle: '',
                        points: [
                            '“Referrer” shall mean either of (i) an existing eligible customer having booked a unit in a Chandak project, and has entered into a registered Agreement to Sell; or (ii) employee of Chandak; or (iii) a visit done not booked person/client (VDNB); or (iv) influencers; and wishes to introduce/refer another person(s) to book a unit in any of the eligible registered real estate project/s to be developed by Chandakor any of its sister concerns/subsidiaries/affiliates (ChandakProject/s”). ‘Referred’ shall mean the eligible person introduced/referred to by the Referrer and who intends to book one or more units in any of the eligible registered real estate Chandak Project/s and registers an agreement for sale for such unit(s).',
                            'Referrer participation in the Referral Reward Program shall be subject to his/her/them producing a copy of a valid and subsisting registered Agreement to Sell executed in his/her/their favor by Chandak.',
                            'Referrer shall not be able to refer existing customer(s) of Chandak. Referrer shall not be able to refer customer(s) who has/have in the last three months: (i) either made enquires (in any form, whether by way of site visit or otherwise with Chandak or (ii) is/are already registered with Chandak as a ‘Direct/Walk-in Customer’ or (iii) has/have come through any of the Chandak’s Channel Partner or any other source. Assigning Referral Reward and determining eligibility as to who qualifies as ‘Referrer’ and ‘Referred’ will be at sole discretion of Reloy and the same shall not be challenged/contested by the Referrer and/or the Referred at any point of time.',
                            'In the event that a referral is submitted twice from different Referrers, then the first referral received will be eligible for the Reward (subject to other applicable terms herein) and shall not be disputed by the other Referrers.',
                            'Referrals are not valid where the Referrer and the Referred party are one and the same person.',
                            'Referrals will be valid for three months from the date a person/party is ‘Referred’ unless such person/party has paid any booking amount to Chandak within the said period of three months.',
                            'By accepting our terms and conditions, both Referrer and Referred represent that they have the authority to disclose the name and details of the person or business to Chandak',
                            'Subject to the terms mentioned herein, the reward will be paid to the Referrer within 90 (ninety) days from the date of registration of the agreement for sale by the Referred party. The reward will be in the form of gift vouchers/cards having value and a validity period with applicable terms and conditions.',
                            'This Referral Reward Program cannot be clubbed with any other offer /scheme, whether run by the Chandak or otherwise.',
                            'Customers who are employees of working either in marketing, sales or CRM departments/team and employees of Reloy will not be eligible for participating in this Referral Reward Program and accordingly shall not be entitled for any reward.',
                            'Reloy will not be liable for any unforeseen delay/deficiency/defect in any product or services disbursed as rewards by it or on account of any dispute relating to right to utilize the product or services subsequent to disbursement of the same.',
                            'The terms and conditions of this program are subject to change at any time. Reloy will intimate the same to the Referrer. This program may be terminated at the discretion of Reloy.',
                            'All disputes shall be subject to exclusive jurisdiction of Mumbai courts.'
                        ],
                        listClassName: `text-neutral font-normal text-[17px] leading-7 font-Gotham_Book`,
                        classNameContainer: 'mt-6'
                    },
                   
                    {
                        id: 'contest_TnC',
                        type: 'CUSTOM',
                        className: 'text-left w-full  py-4 ',
                        components: [
                            {
                                type: 'TEXT',
                                content:
                                    'Terms and Conditions for Brand Quiz Contest:',
                                className: `mt-4 text-[22px] underline  mt-4 font-semibold font-Gotham_Book`
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '• The contest will run from',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'20th June’25 to 25th June’25.',
                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Entries submitted outside this period will not be considered.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Participants who score a perfect 10 will be shortlisted for a lucky draw.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• 3 lucky winners will be randomly selected from the pool of participants who answer all 10 questions correctly.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Participants can play the contest only once.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Each participant needs to share their name, number and email id and give consent to us to get in touch with them to promote our projects.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• The selected winner will receive a',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'gift voucher as below:',
                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'CUSTOM',
                                        className: 'pt-1 pl-2 lg:pl-10',
                                        components: [
                                            {
                                                type: 'TEXT',
                                                content: '1',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            }, 
                                            {
                                                type: 'SUP',
                                                content: 'st',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                            {
                                                type: 'TEXT',
                                                content: ' - Myntra voucher worth ₹2,500',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                        ]
                                    },
                                    {
                                        type: 'CUSTOM',
                                        className: 'pt-1 pl-2 lg:pl-10',
                                        components: [
                                            {
                                                type: 'TEXT',
                                                content: '2',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            }, 
                                            {
                                                type: 'SUP',
                                                content: 'nd',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                            {
                                                type: 'TEXT',
                                                content: ' - Myntra voucher worth ₹1,500',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                        ]
                                    },
                                    {
                                        type: 'CUSTOM',
                                        className: 'pt-1 pl-2 lg:pl-10',
                                        components: [
                                            {
                                                type: 'TEXT',
                                                content: '3',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            }, 
                                            {
                                                type: 'SUP',
                                                content: 'rd',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                            {
                                                type: 'TEXT',
                                                content: ' - Myntra voucher worth ₹1,000',
                                                className: ` inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                            },
                                        ]
                                    },
                                   
                                  
                                    {
                                        type: 'TEXT',
                                        content: '• The prize is non-transferable and cannot be exchanged for cash or other alternatives.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Winners will be declared by July 2025.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Chandak Group reserves the right to modify or cancel the contest at any time without prior notice.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• The decision of Chandak Group regarding the contest and winner selection shall be final and binding.',
                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    }
                                    
                                ]
                            },
                          
                        ]
                    },
                    {
                        id: 'contest_TnC',
                        type: 'CUSTOM',
                        className: 'text-left w-full  py-4 ',
                        components: [
                            {
                                type: 'TEXT',
                                content:
                                    'Referral Contest – Terms & Conditions (25th April to 25th June 2025)',
                                className: `mt-4 text-[22px] underline  mt-4 font-semibold font-Gotham_Book`
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '1. Contest Duration',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold`
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• The contest will be active from',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            '25th April 2025 to 25th June 2025.',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Entries received outside this period will not be considered.',

                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '2. Eligibility Criteria',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• The contest is open to',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            'all Chandak Group Customers',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'who are part of the Chandak Connect Circle loyalty program.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• To participate, members/customers must refer a potential homebuyer during the contest period.',

                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Only those referrals that result in a successful home booking will qualify for the lucky draw.',

                                        className: ` text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '3. Participation Requirements',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• To participate, customers must provide their',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            'full name, contact number, and email ID.',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '• Participants must also ',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'consent to being contacted',

                                        className: `inline text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'by Chandak Group for promotional purposes.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '4. Winner Selection',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Booking should be completed',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            'latest by 25th June 2025 ',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },

                                    {
                                        type: 'TEXT',
                                        content: 'for consideration.',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                
                                    {
                                        type: 'TEXT',
                                        content: '• All participants with successful referrals will be entered into a',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'lucky draw.',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content:'• Five (5) winners',

                                        className: `inline text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'will be randomly selected from the eligible pool.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '• Winners will be announced by ',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'June 2025.',

                                        className: `inline text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '5. Rewards',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Each winner will receive an',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            'Accor Hotels voucher worth ₹15,000.',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '• The prize is ',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'non-transferable',

                                        className: `inline text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'and cannot be redeemed for cash or exchanged for any other benefits.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: 'mt-6',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '6. General Conditions',

                                        className: `font-semibold text-neutral font-normal text-[17px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: '• Chandak Group reserves the right to',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:
                                            'modify, extend, or cancel',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'the contest at any time without prior notice.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },
                            {
                                type: 'CUSTOM',
                                className: '',
                                components: [
                                    {
                                        type: 'TEXT',
                                        content: '• The decision of ',

                                        className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'Chandak Group',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'regarding the contest and selection of winners will be',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                    {
                                        type: 'TEXT',
                                        content:'final and binding',

                                        className: `inline ml-1 text-neutral font-semibold text-[16px] leading-7 font-Gotham_Bold `
                                    },
                                    {
                                        type: 'TEXT',
                                        content: 'on all participants.',

                                        className: `inline ml-1 text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                                    },
                                ]
                            },


                            // {
                            //     type: 'LIST',
                            //     listStyle: '',
                            //     points: [
                            //         '• Entries submitted outside this period will not be considered.',
                            //         '• Participants who score a perfect 10 will be shortlisted for a lucky draw.',
                            //         '• One lucky winner will be randomly selected from the pool of participants who answer all 10 questions correctly.',
                            //         '• Participants can play the contest only once.',
                            //         '• Each participant needs to share their name, number and email id and give consent to us to get in touch with them to promote our projects.'
                            //     ],
                            //     listClassName: `text-neutral font-normal text-[17px] leading-7 font-Gotham_Book`,
                            //     classNameContainer: ''
                            // },
                            // {
                            //     type: 'CUSTOM',
                            //     className: '-mt-1',
                            //     components: [
                            //         {
                            //             type: 'TEXT',
                            //             content:
                            //                 '• The selected winner will receive a',

                            //             className: `inline text-neutral font-normal text-[17px] leading-7 font-Gotham_Book `
                            //         },
                            //         {
                            //             type: 'TEXT',
                            //             content: 'voucher worth ₹5,000.',

                            //             className: `inline ml-1 text-neutral font-semibold text-[17px] leading-7 font-Gotham_Bold `
                            //         }
                            //     ]
                            // },
                            // {
                            //     type: 'LIST',
                            //     listStyle: '',
                            //     points: [
                            //         '• The prize is non-transferable and cannot be exchanged for cash or other alternatives.',
                            //         '• Winners will be declared by April 2025.',
                            //         '• Chandak Group reserves the right to modify or cancel the contest at any time without prior notice.',
                            //         '• The decision of Chandak Group regarding the contest and winner selection shall be final and binding.'
                            //     ],
                            //     listClassName: `text-neutral  font-normal text-[17px] leading-7 font-Gotham_Book`,
                            //     classNameContainer: ''
                            // }
                        ]
                    }
                ]
            }
        ]
    },
    myProfile: {
        appContainerClassName: 'text-primary border-primary-focus'
    },
    footer: {
        backgroundColor: '',
        containerClassName: 'bg-primary',
        content:
            'Reloy is run by Loyalie IT-Solutions Pvt. Ltd. This referral program is run by Loyalie IT Solutions Pvt. Ltd. and the referral payout will be processed by them. Loyalie IT Solutions Pvt. Ltd. is registered as a Real Estate Agent under RERA in Maharashtra MAHARERA NO - A51900010267 | Haryana RERA No. - HRERA-PKL-REA-239-2020 | Tamil Nadu RERA NO - TN/Agent/0092/2023 | Karnataka RERA NO-PRM/KA/RERA/1251/309/AG/180524/000935 | West Bengal RERA NO – HIRA/A/KOL/2019/000350 | Uttar Pradesh RERA NO – UPRERAAGT22593 | Gujarat RERA No: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01891/090327R1 | Delhi RERA Application Reference No: 22-3754-2891 | Goa RERA NO – AGGO02210817 | Telangana RERA NO – A02500001321 | maharera.mahaonline.gov.in | haryanarera.gov.in | www.tnrera.in | rera.karnataka.gov.in | http://hira.wb.gov.in | https://www.up-rera.in | https://gujrera.gujarat.gov.in | https://rera.delhi.gov.in | https://rera.goa.gov.in | http://rera.telangana.gov.in'
    },

    referralForm: {
        disableInfluencerLink: false,
        referAnyProject: false,
        userTypes: {
            length: 3,
            siteVisitor: false,
            siteVisitorHeading: '',
            bookedCustomer: true,
            bookedCustomerHeading1: 'I own a',
            // bookedCustomerHeading2: 'JP Infra Property',

            employee: true,
            employeeHeading1: 'I am a',
            // employeeHeading1: 'JP Infra Employee',

            salesAdmin: true,
            salesAdminHeading1: 'I am an',
            // salesAdminHeading2: 'JP Infra Sales Admin',

            influencer: false,
            influencerHeading: ''
        },
        customConfig: {
            welcomeContent: '',
            headingColor: 'text-black',
            userBgColor: 'bg-transparent',
            borderColor: 'border-primary',
            animateUserType: true
        },
        leadEmailMandatory: true
    }
};
export default ChandakConfig;
